import $ from "jquery";
import slick from "slick-carousel";

(function ($) {
	$(".sliderGallery").slick({
		slidesToShow: 1,
		slidesToScroll: 1,
		infinite: false,
		// prevArrow: '<button type="button" class="slick-prev"></button>',
		// nextArrow: '<button type="button" class="slick-next"></button>',
		// dots: true,
		arrows: false,
		mobileFirst: true,
		asNavFor: ".sliderGallery--nav",
		responsive: [
			{
				breakpoint: 767,
				settings: "unslick"
			}
		]
	});

	$(".sliderGallery--nav").slick({
		slidesToShow: 4,
		slidesToScroll: 1,
		asNavFor: ".sliderGallery",
		dots: false,
		arrows: false,
		centerMode: false,
		infinite: false,
		focusOnSelect: true,
		mobileFirst: true,
		responsive: [
			{
				breakpoint: 767,
				settings: "unslick"
			}
		]
	});
})(jQuery);

function slickCarousel() {
	$(".sectionFeatured__results").slick({
		slidesToShow: 4,
		slidesToScroll: 1,
		infinite: true,
		responsive: [
			{
				breakpoint: 1024,
				settings: {
					slidesToShow: 3,
					slidesToScroll: 1,
					centerMode: false,
					arrows: false,
					infinite: true,
					focusOnSelect: true
				}
			},
			{
				breakpoint: 480,
				settings: {
					slidesToShow: 1,
					slidesToScroll: 1,
					centerMode: true,
					arrows: false,
					infinite: false,
					focusOnSelect: true
				}
			}
		]
	});
}
